export default __webpack_public_path__ + "static/media/jeremy-thomas-O6N9RV2rzX8-unsplash.e0723051.jpg";